import { FormControl, FormHelperText, InputLabel, MenuItem } from "@material-ui/core";
import { Field, useFormikContext } from "formik";
import { Select } from "formik-material-ui";
import React from "react";

export default function FormikSelectField({
  idPrefix = "",
  options,
  name,
  label,
  getValueForOption,
  getLabelForOption,
  multiple = false,
  ...props
}) {
  const formik = useFormikContext();
  return (
    <FormControl error={formik.touched[name] && Boolean(formik.errors[name])} {...props} fullWidth>
      <InputLabel id={(idPrefix ? idPrefix + "-" + name : name) + "-label"}>{label}</InputLabel>
      <Field
        component={Select}
        id={idPrefix ? idPrefix + "-" + name : name}
        name={name}
        type="text"
        fullWidth
        multiple={multiple}
        MenuProps={
          // Slight hack/bug. When 'multiple' options allowed, select-box moves annoyingly. This fixes it in place
          multiple
            ? {
                getContentAnchorEl: () => null,
              }
            : {}
        }
        FormHelperTextProps={{ "data-cy": (idPrefix ? idPrefix + "-" + props.name : props.name) + "-helper-text" }}
      >
        {options.map((option, i) => (
          <MenuItem key={i} value={getValueForOption ? getValueForOption(option) : option}>
            {getLabelForOption ? getLabelForOption(option) : option}
          </MenuItem>
        ))}
      </Field>
      {formik.touched[name] && Boolean(formik.errors[name]) && <FormHelperText>{formik.errors[name]}</FormHelperText>}
    </FormControl>
  );
}
